import React from 'react';
import Helmet from 'react-helmet';

export const BaseHead = () => (
  <Helmet>
    <html lang="fr"></html>
    <title>L'envol du souffle | Marielle Tuil-Bensimon</title>
    <meta
      name="description"
      content="Présentation, ateliers et informations de Marielle Tuil-Bensimon - Praticienne en Shiatsu traditionnel"
    />
  </Helmet>
);
